import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { decimal, date, surcharge, dateRange, validString } from "Components/shared/helpers/validations";

const maxDimension = Yup.mixed().when("tab", {
    is: (tab) => tab <= 1,
    then: Yup.object().shape(
        reverseShape({
            length: decimal.required(),
            width: decimal.required(),
            height: decimal.required()
        })
    )
});

const maxWeight = Yup.mixed().when("tab", {
    is: (tab) => tab <= 1,
    then: decimal.required()
});

export const CreateEditVersionSchema = Yup.object().shape(
    reverseShape({
        tab: validString, // is here just for conditionals
        name: validString.optional(),
        code: validString.optional(),
        settingID: validString.optional(),
        maxWeight: maxWeight,
        maxDimension: maxDimension,
        surcharge: surcharge,
        validFrom: date.required(),
        validTo: date.required().concat(dateRange),
        serviceTypes: Yup.mixed().optional(),
        areaName: Yup.mixed().optional(),
        deliveryTypes: Yup.mixed().optional(),
        states: Yup.mixed().optional()
    })
);
